var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgK8SCronJob = function SvgK8SCronJob(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 2h10a1 1 0 0 1 1 1v4h-1V3H3v10h4v1H3a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 15a3.5 3.5 0 1 1 0-7 3.5 3.5 0 0 1 0 7m0-6a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m13 12.293-1-1V10h-1v1.707L12.293 13zM9.875 7.302a2 2 0 1 0-2.573 2.573 4.5 4.5 0 0 0-.255.97 3.001 3.001 0 1 1 3.798-3.798 4.5 4.5 0 0 0-.97.255"
  })));
};
export default SvgK8SCronJob;